import * as Sentry from '@sentry/browser';
import { IGNORE_ERRORS, DENY_URLS, filterEvent } from './sentry_filters';

const OUR_HOSTS = ['www.artfullywalls.com', 'dev.artfullywalls.com']; // artfullywalls / awall-staging Heroku apps
const STAGING_HOST = 'dev.artfullywalls.com';

// Several packs can load on one page (/user/works: arts + user_works), and renderTagger /
// renderCategorization run per mount, so only the first call initializes.
export const initSentry = () => {
  if (!window.sentry_dsn || Sentry.getClient()) return;
  Sentry.init({
    dsn: window.sentry_dsn,
    tracesSampleRate: 0,
    ignoreErrors: IGNORE_ERRORS,
    denyUrls: DENY_URLS,
    beforeSend: (event, hint) => filterEvent(event, hint, {
      hostname: window.location.hostname,
      webdriver: navigator.webdriver,
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      ourHosts: OUR_HOSTS,
      stagingHost: STAGING_HOST
    })
  });
  window.Sentry = Sentry;
};
